document.addEventListener('alpine:init', () => {
  Alpine.data('regionIntro', () => ({
    reportTop: 0,

    reportFloating: false,

    report: {
      ':style'() {
        return {
          transform: `translate3d(0, ${this.reportTop}px, 0)`,
        };
      },
    },

    init() {
      if (this.$refs.side) {
        document.body.append(this.$refs.floatingButton);

        window.addEventListener('scroll', () => this.onScroll());

        this.$refs.floatingButton.addEventListener('click', () =>
          this.$refs.side.scrollIntoView({ behavior: 'smooth' })
        );
      }
    },

    onScroll() {
      const rect = this.$refs.side.getBoundingClientRect();
      const top = Math.max(-rect.top, 0);
      const maxTop = Math.max(rect.height - this.$refs.report.offsetHeight, 0);
      this.reportTop = Math.min(top, maxTop);

      if (top > 0 && this.reportFloating) {
        this.$refs.floatingButton.classList.add('visible');
      } else {
        this.$refs.floatingButton.classList.remove('visible');
      }
    },
  }));
});